var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_missing)?_c('div',{staticClass:"block national-system"},[_c('h3',{staticClass:"subtitle is-5 has-text-danger"},[_c('font-awesome-icon',{attrs:{"icon":"exclamation-triangle"}}),_vm._v(" "+_vm._s(_vm.title)+" ")],1),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }